import { NotifyHelper } from "../../../helpers/toast";
import { ePhongBanActionsObj } from "../../action-types/category/IPhongBanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phongBanActions = {
    ...generateActions(ePhongBanActionsObj, "PHONG_BAN"),
    ...generateActionForKey(ePhongBanActionsObj, "PHONG_BAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongBanActionsObj, "PHONG_BAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongBanActionsObj, "PHONG_BAN", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(ePhongBanActionsObj, "PHONG_BAN", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
